import React, { useEffect, useState } from "react";

import { IPicture } from "../../../model/shared/IPicture";
import { ProductsService } from "../service";
import { ErrorToast, SuccessToast } from "../../../shared/toasters/toasters";
import { IProductsList, IProductVariation } from "../dto/IProducts";

import { useDispatch, useSelector } from "react-redux";
import { IAllStates } from "../../../store/rootReducer";

import { IBrand } from "../../brand/dto/IBrand";

import ProductVariation from "./ProductVariation";
import { Pagination } from "../../../shared/paginations/Paginations";
import VariationUpdateForm from "../content/components/VariationUpdateForm";
import { ActualFileObject } from "filepond";

interface Props {
  currentProduct: any;
  setCurrentProduct: any;
  isWorkflow: boolean;
}
const variationInitial = {
  title: null,
  lang: "",
  bullets: "",
  introText: "",
  description: "",
  subtitle: "",
  blocks: {},
} as any;
//setCurrentProduct moram rijesiti sa baseDataProduct svuda
export const PreviewProudctModalVariations = ({
  currentProduct,
  setCurrentProduct,
}: Props) => {
  const [variationPagination, setVariationPagination] = useState({
    page: 1,
    perPage: 10,
  });
  const [triggerUpdate, setTriggerUpdate] = useState(false);
  const [allBlocks, setAllBlocks] = useState([] as any);
  const handlePages = (updatePage: number) => {
    setVariationPagination({ ...variationPagination, page: updatePage });
    setPage(updatePage);
  };
  const [productStaticts, setProductStaticts] = useState({} as any);
  const [certainBlocks, setCertainBlocks] = useState([]);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [selectedImage, setSelectedImage] = useState<IPicture>();
  const [brandList, setBrandList] = useState<IBrand[]>([]);
  const [currentVariation, setCurrentVariation] = useState<IProductVariation>(
    variationInitial as any
  );
  const { websiteEnum } = useSelector((state: IAllStates) => state.enums);
  const [showDialog, setShowDialog] = useState(false);
  const [detectedChange, setDetectedChange] = useState(false);

  const handleCloseConfirm = () => {
    setShowVariationModal((prev: boolean) => !prev);
    setCurrentVariation(variationInitial as any);
  };
  const currentLanguage = localStorage.getItem("language");

  const [triggerVariationUpdate, setTriggerVariationUpdate] = useState(false);
  const [currentVariationTranslation, setCurrentVariationTranslation] =
    useState<IProductVariation>();
  const [variationList, setVariationList] = useState<IProductVariation[]>([]);

  const [showVariationModal, setShowVariationModal] = useState(false);

  const handleCloseVariation = () => {
    setShowVariationModal((prev: boolean) => !prev);
    setCurrentVariation(variationInitial as any);
  };
  const handleClose = () => {
    if (detectedChange) {
      setShowDialog(true);
    } else {
      setShowVariationModal(false);
      setCurrentVariation(variationInitial as any);
    }
  };

  const handleShow = () => {
    setShowVariationModal(true);
    setCertainBlocks(currentProduct?.block as any);
  };

  const getAllVariations = ({
    variationPagination,
    id,
    setVariationList,
    setTotalPages,
    setPage,
    setVariationPagination,
  }: any) => {
    ProductsService.getAllVariations({
      ...variationPagination,
      product: Number(id),
    })
      .then((response) => {
        if (
          variationPagination?.page > 1 &&
          variationPagination?.page > response?.totalPages
        ) {
          setPage(response?.totalPages);
          setVariationPagination({
            ...variationPagination,
            page: response?.totalPages,
          });
        }
        setVariationList(response.data);
        setTotalPages(Math.ceil(response?.count / response?.perPage));
      })
      .catch((error) => ErrorToast(error));
  };

  useEffect(() => {
    getAllVariations({
      variationPagination: variationPagination,
      id: currentProduct?.id,
      setVariationList: setVariationList,
      setTotalPages: setTotalPages,
      setPage: setPage,
      setVariationPagination: setVariationPagination,
    });
  }, [currentProduct?.id, triggerVariationUpdate, variationPagination]);
  return (
    <>
      <div className="row mt-3">
        {variationList?.map((variation) => (
          <ProductVariation
            setTriggerVariationUpdate={setTriggerVariationUpdate}
            currentProduct={currentProduct as IProductsList}
            //  isWorkflowUpdate={isWorkflowUpdate}
            //  handleCheckVariation={handleCheckVariation}
            setCurrentVariationTranslation={setCurrentVariationTranslation}
            setCurrentVariation={setCurrentVariation}
            setVariationList={setVariationList}
            handleShow={handleShow}
            variation={variation}
            key={variation?.id}
            setCurrentProduct={setCurrentProduct}
          />
        ))}

        <div className="col-12 d-flex justify-content-end ">
          {totalPages <= 1 ? (
            ""
          ) : (
            <Pagination
              page={page}
              totalPages={totalPages}
              handlePagination={handlePages}
            />
          )}
        </div>
      </div>
      {currentVariation?.id && (
        <VariationUpdateForm
          productStaticts={productStaticts}
          currentVariation={currentVariationTranslation}
          variationId={currentVariation?.id}
          setCurrentVariation={setCurrentVariationTranslation}
          showVariationModal={showVariationModal}
          handleClose={handleClose}
          // certainBlocks={certainBlocks}
          setTriggerUpdate={setTriggerVariationUpdate}
          setDetectedChange={setDetectedChange}
          handleCloseVariation={handleCloseVariation}
          isWorkflowPage={false}
          // workflowId={id}
          productId={currentProduct?.id}
          setCurrentProduct={setCurrentProduct}
        />
      )}
    </>
  );
};
